// Step 25 — Command Center findings queue.
//
// Reuses the Step 19 AIFindingCard verbatim so findings look
// identical to every other AI workspace (buyer/contract/execution).
// Findings come from `commandFindings` — a projection over blocking
// items across all domains + unread notifications. No new taxonomy.

import AIFindingCard from "../intelligence/AIFindingCard";
import { AIEmpty, AISection } from "../AIPrimitives";
import { commandFindings } from "./helpers";

export default function AICommandFindings({
  actions,
  contracts,
  situation,
  notifications,
  workspaceId,
  now,
}) {
  const findings = commandFindings({
    actions, contracts, situation, notifications, now,
  });
  if (findings.length === 0) {
    return (
      <AISection title="Fynd">
        <AIEmpty
          title="Inga öppna fynd i Command Center"
          hint={
            "Fynd bygger på deterministiska poster: blockerade/försenade " +
            "åtgärder, avtalsläge, beredskapsgap och olästa notiser."
          }
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Fynd"
      right={
        <span className="qai-page-section-hint">
          {findings.length} post{findings.length === 1 ? "" : "er"}
        </span>
      }
    >
      <div className="qai-attention-queue">
        {findings.map((f) => (
          <AIFindingCard key={f.key} finding={f} workspaceId={workspaceId} />
        ))}
      </div>
    </AISection>
  );
}
